export class CustomerDetailsResponse {
    customerNumber: string;
    accountGroup: string;
    salesOrg: string;
    division: string;
    distributionChannel: string;
    customerType: string;
    salesArea: SalesArea;
}

export class SalesArea {
    partner: Partner[];
}

export class Partner {
    number: string;
    type: string;
    deleteIndicator: string;
}

export default CustomerDetailsResponse;
